export default {

        /**
         * Process events
         */
        AUTOBOOKING_IN_PROCESS: 4,
};



// WEBPACK FOOTER //
// ./src/app/modules/trip/config/tripCanBeBookedStatuses.constant.js